function cleanText(pattern) {
  // On supprime tous les accents et caractères spéciaux
  return pattern
    .toLocaleLowerCase('fr-FR')
    .normalize('NFD')
    .replaceAll(/[^a-zA-Z0-9]/g, '');
}

function isTextMatchingPattern(text, pattern) {
  // on check si le texte contient le pattern,
  // plus pertinent que le "commence par" dans le cas d'une facette dont le nom contient plusieurs mots
  return text.includes(pattern);
}

export function initOnReset(filtersForm, onReset) {
  // Si on réinitialise le formulaire de recherche, on l'envoie de nouveau pour avoir les nouvelles données
  filtersForm.addEventListener('reset', () => {
    // On force la remise à zéro des champs
    filtersForm
      .querySelectorAll('.facette input[type="radio"][value=""]')
      .forEach((input) => (input.checked = true));
    onReset();
  });
}

export function initCheckBoxTous(filtersForm) {
  // Au clic sur les X d'une facette, on sélectionne son équivalent "Tous" pour simuler la suppresion
  // du filtre
  filtersForm
    .querySelectorAll('.facette-selectionnee [data-action="filters:remove"]')
    .forEach((button) => {
      button.addEventListener('click', () => {
        const value = button.getAttribute('data-value');
        const radio = filtersForm.querySelector(
          `.facette input[type="radio"][value=""][name="${value}"]`,
        );
        radio && radio.click();
      });
    });
}

export function initOnChangeFacette(filtersForm, onChange) {
  // On soumet le formulaire de recherche à la moindre modification dans les facettes
  filtersForm
    .querySelectorAll('.facette input[type="radio"]')
    .forEach((input) => {
      input.addEventListener('change', onChange);
    });
}

export function initInputSearchFacette(filtersForm) {
  // Gestion du filtrage des facettes affichées selon la valeur indiquée dans le champ de recherche dédié à un type de facette
  filtersForm
    .querySelectorAll('.facette input[type="search"]')
    .forEach((input) => {
      const facetteElement = input.closest('.facette');
      input.addEventListener('input', () => {
        const pattern = cleanText(input.value);
        const facetteValueElements =
          facetteElement.querySelectorAll('.facette-value');
        facetteValueElements.forEach((facetteValueElement) => {
          const value = cleanText(
            facetteValueElement.getAttribute('data-value'),
          );
          if (isTextMatchingPattern(value, pattern)) {
            facetteValueElement.style.display = 'initial';
          } else {
            facetteValueElement.style.display = 'none';
          }
        });
      });
    });
}
